import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

import {
    FaPhoneAlt,
    FaEnvelope,
    FaMapMarkerAlt,
    FaInstagram,
    FaFacebookF,
    FaYoutube
} from "react-icons/fa";

const Footer = () => {

    const scrollTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    return (
        <footer className="footer">

            <div className="footer-container">

                {/* =================================================
                    LEFT SECTION
                ================================================= */}

                <div className="footer-left">

                    {/* LOGO */}
                    <div className="footer-logo">
                        <img
                            src="/images/logo.png"
                            alt="PRT Academy IT Training Institute in Hyderabad"
                        />
                    </div>


                    {/* TAGLINE */}
                    <p className="tagline">
                        Training <span>|</span> Internship <span>|</span> Placement
                    </p>


                    {/* CONTACT DETAILS */}
                    <div className="contact">

                        <a
                            href="tel:+916302005435"
                            className="contact-item"
                        >
                            <FaPhoneAlt className="icon" />
                            <span>+91 6302005435</span>
                        </a>


                        <a
                            href="tel:+919398219604"
                            className="contact-item"
                        >
                            <FaPhoneAlt className="icon" />
                            <span>+91 9398219604</span>
                        </a>


                        <a
                            href="mailto:support@prtacademy.com"
                            className="contact-item"
                        >
                            <FaEnvelope className="icon" />
                            <span>support@prtacademy.com</span>
                        </a>

                    </div>


                    {/* =================================================
                        SOCIAL MEDIA
                    ================================================= */}

                    <div className="footer-social">

                        <span className="footer-social-title">
                            Follow PRT Academy
                        </span>

                        <div className="footer-social-links">

                            {/* PRT ACADEMY INSTAGRAM */}
                            <a
                                href="https://www.instagram.com/prtacademykphb/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-link instagram"
                                aria-label="PRT Academy Instagram"
                            >
                                <FaInstagram />
                                <span>Instagram</span>
                            </a>


                            {/* PRT DIGITAL MARKETING INSTAGRAM */}
                            <a
                                href="https://www.instagram.com/prtdigitalmarketingservices/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-link instagram"
                                aria-label="PRT Digital Marketing Services Instagram"
                            >
                                <FaInstagram />
                                <span>Digital Marketing</span>
                            </a>


                            {/* YOUTUBE */}
                            <a
                                href="https://www.youtube.com/@PRTAcademyOfficial"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-link youtube"
                                aria-label="PRT Academy YouTube"
                            >
                                <FaYoutube />
                                <span>YouTube</span>
                            </a>


                            {/* FACEBOOK */}
                            <a
                                href="https://www.facebook.com/prtacademykphbcolony"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-link facebook"
                                aria-label="PRT Academy Facebook"
                            >
                                <FaFacebookF />
                                <span>Facebook</span>
                            </a>

                        </div>

                    </div>

                </div>


                {/* =================================================
                    QUICK LINKS
                ================================================= */}

                <div className="footer-links">

                    <h4>Quick Links</h4>

                    <ul>

                        <li>
                            <Link to="/" onClick={scrollTop}>
                                Home
                            </Link>
                        </li>

                        <li>
                            <Link to="/courses" onClick={scrollTop}>
                                Courses
                            </Link>
                        </li>

                        <li>
                            <Link to="/internships" onClick={scrollTop}>
                                Internships
                            </Link>
                        </li>

                        <li>
                            <Link to="/placements" onClick={scrollTop}>
                                Placements
                            </Link>
                        </li>

                        <li>
                            <Link to="/contact" onClick={scrollTop}>
                                Contact
                            </Link>
                        </li>

                    </ul>

                </div>


                {/* =================================================
                    COMPANY
                ================================================= */}

                <div className="footer-links">

                    <h4>Company</h4>

                    <ul>

                        <li>
                            <Link to="/about" onClick={scrollTop}>
                                About Us
                            </Link>
                        </li>

                        <li>
                            <Link to="/reviews" onClick={scrollTop}>
                                Reviews
                            </Link>
                        </li>

                        <li>
                            <Link to="/careers" onClick={scrollTop}>
                                Careers
                            </Link>
                        </li>

                        <li>
                            <Link to="/blog" onClick={scrollTop}>
                                Blog
                            </Link>
                        </li>

                    </ul>

                </div>


                {/* =================================================
                    LOCATION
                ================================================= */}

                <div className="footer-right">

                    <h4>
                        <FaMapMarkerAlt className="icon" />
                        Our Location
                    </h4>

                    <a
                        href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                            "Plot No.142, Third Floor, Balaji Commercial Complex, Bhagyanagar Colony, KPHB, Hyderabad, Telangana 500072"
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="location-link"
                    >
                        <span>
                            Plot No.142, Third Floor,
                            <br />
                            Balaji Commercial Complex,
                            <br />
                            Bhagyanagar Colony,
                            <br />
                            KPHB-HYD-500072.
                        </span>
                    </a>

                </div>

            </div>


            {/* =================================================
                FOOTER BOTTOM
            ================================================= */}

            <div className="footer-bottom">

                <p>
                    © 2026 PRT Academy. All rights reserved.
                </p>

            </div>

        </footer>
    );
};

export default Footer;